import svgToTinyDataUri from '../svg-to-mini-data-uri';

export const paperlessIcon = svgToTinyDataUri(
  `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M4.66667 6L2 9.33333L4.66667 10.6667" stroke="#222222" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2 9.33333H8C9.06087 9.33333 10.0783 8.91191 10.8284 8.16176C11.5786 7.41161 12 6.3942 12 5.33333" stroke="#222222" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M11.3333 10L14 6.66667L11.3333 5.33333" stroke="#222222" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14 6.66667H8C6.93913 6.66667 5.92172 7.08809 5.17157 7.83824C4.42143 8.58839 4 9.6058 4 10.6667" stroke="#222222" stroke-width="1.33" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`
);
